import { render, staticRenderFns } from "./DeviceStatusReports.vue?vue&type=template&id=50ed81c6&scoped=true&"
import script from "./DeviceStatusReports.vue?vue&type=script&lang=js&"
export * from "./DeviceStatusReports.vue?vue&type=script&lang=js&"
import style0 from "./DeviceStatusReports.vue?vue&type=style&index=0&id=50ed81c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ed81c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src414009122/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50ed81c6')) {
      api.createRecord('50ed81c6', component.options)
    } else {
      api.reload('50ed81c6', component.options)
    }
    module.hot.accept("./DeviceStatusReports.vue?vue&type=template&id=50ed81c6&scoped=true&", function () {
      api.rerender('50ed81c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Devices/StatusReports/DeviceStatusReports.vue"
export default component.exports